/*------------------------------------*\
    MODULES
\*------------------------------------*/
import { Fancybox } from "@fancyapps/ui";

/*------------------------------------*\
    ZOOMED IMG
\*------------------------------------*/
class ZoomedImg {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        Fancybox.bind('[data-fancybox]');
    }
}

export default ZoomedImg;
